import { styled } from 'styled-components';
import mediaQuery, { Breakpoint, breakpoints } from '@/styles/mediaQuery';

export const RegisterTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.sizes.lg};
  font-weight: ${({ theme }) => theme.typography.weight.regular};

  ${mediaQuery.custom(breakpoints[Breakpoint.XS])} {
    font-size: ${({ theme }) => theme.typography.sizes.sm};
    margin-bottom: ${({ theme }) => theme.spaces.padding.sm};
  }
`;

export const RegisterSubtitle = styled.p`
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};
`;

export const InputContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spaces.gap.md};
  width: 100%;
  margin-top: ${({ theme }) => theme.spaces.padding.md};
`;

export const TermsNoticeContainer = styled.div`
  margin-top: ${({ theme }) => theme.spaces.padding.md};
  margin-bottom: ${({ theme }) => theme.spaces.padding.md};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  text-align: center;

  a {
    color: ${({ theme }) => theme.system.neutral.text.primary};
  }
`;

export const TestimonialContainer = styled.div`
  max-width: 400px;
  flex: 1;

  ${mediaQuery.custom(breakpoints[Breakpoint.SM])} {
    display: none;
  }
`;

export const RegisterFormSectionContainer = styled.div`
  flex: 2;
  max-width: 500px;
`;

export const RegistrationLayoutWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spaces.gap.xxl};

  ${mediaQuery.custom(breakpoints[Breakpoint.SM])} {
    justify-content: center;
  }
`;
